<div class="sub-container">
    <app-table *ngIf="dataSource !== null" [data]="dataSource" [itemsPerPage]="5"
        (itemDeleted)="eliminarObjetivo($event)" (designResponsive)="actualizarDiseno($event)"
        (stateChanged)="onStateChanged()" (reloadObjectives)="reloadObjectivesList()"></app-table>

    <!-- Banner Academy Slider -->
    <div class="academy-banner-slider">
        <div class="banner-container">
            <!-- Slide 1: Academy -->
            <div class="banner-slide" [class.active]="currentSlide === 0">
                <div class="banner-background">
                    <div class="banner-overlay"></div>
                </div>
                <div class="banner-content">
                    <div class="banner-text">
                        <h3 class="banner-title">Lo nuevo en Academy</h3>
                        <p class="banner-description">Descubre recursos exclusivos para inspirarte y llevar tus
                            objetivos al siguiente nivel.</p>
                    </div>
                    <button class="banner-button" (click)="navigateToAcademyFromBanner()">
                        <span>Ver ahora</span>
                    </button>
                </div>
            </div>

            <!-- Slide 2: Expertos -->
            <div class="banner-slide" [class.active]="currentSlide === 1">
                <div class="banner-background">
                    <div class="banner-overlay"></div>
                </div>
                <div class="banner-content">
                    <div class="banner-text">
                        <h3 class="banner-title">Conéctate con expertos</h3>
                        <p class="banner-description">Agenda una sesión y recibe orientación personalizada para
                            profundizar en tus prioridades.</p>
                    </div>
                    <button class="banner-button" (click)="navigateToMentorsFromBanner()">
                        <span>Agendar ahora</span>
                    </button>
                </div>
            </div>

            <!-- Slide 3: Objetivos -->
            <div class="banner-slide" [class.active]="currentSlide === 2">
                <div class="banner-background">
                    <div class="banner-overlay"></div>
                </div>
                <div class="banner-content">
                    <div class="banner-text">
                        <h3 class="banner-title">Profundiza tus objetivos</h3>
                        <p class="banner-description">Revisa, ajusta y fortalece tu plan de vida con tips prácticos y
                            ejercicios de reflexión.</p>
                    </div>
                    <button class="banner-button">
                        <span>Ir a objetivos</span>
                    </button>
                </div>
            </div>
        </div>

        <!-- Indicadores del slider -->
        <div class="banner-indicators">
            <div class="indicator" [class.active]="currentSlide === 0" (click)="goToSlide(0)"></div>
            <div class="indicator" [class.active]="currentSlide === 1" (click)="goToSlide(1)"></div>
            <div class="indicator" [class.active]="currentSlide === 2" (click)="goToSlide(2)"></div>
        </div>
    </div>

    <!-- Cards de Puntos de Dolor - Aspectos Críticos del Gap -->
    <div *ngIf="criticalGapAreas && criticalGapAreas.length > 0" class="pain-points-section">
        <!-- <h3 class="pain-points-title">Puntos de dolor críticos</h3> -->
        <div class="pain-points-cards">
            <div *ngFor="let area of criticalGapAreas; let i = index" class="pain-point-card">
                <div class="card-header">
                    <div class="lock-icon">
                        <img src="assets/icons/press.svg" alt="Press icon" class="press-icon">
                    </div>
                    <div class="card-title">
                        <h4>Punto de dolor</h4>
                        <p class="area-name">{{ area.name }}</p>
                        <span class="gap-text">Brecha de {{ area.gap }} puntos</span>
                    </div>
                </div>
                <div class="card-content">
                    <p class="area-description">{{ area.description }} <strong class="academy-link"
                            (click)="navigateToAcademy(area.name)">Academy</strong> </p>
                </div>
            </div>
        </div>
    </div>

    <!-- <div *ngIf="dataSource !== null && dataSource.length !== 0" class="statistics">
        <div class="statistic">
            <div class="statistics-header">
                <h2>Recientemente añadido</h2>
                <p>Objetivos y actividades recientemente añadidas a tu página</p>
            </div>
            <div class="history-objectives">
                <div class="list-item" *ngFor="let item of dataHistory; let i = index">
                    <button mat-icon-button>
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <span class="title">Objetivo #{{ i + 1 }}</span>
                    <span class="description">{{ item.name }}</span>
                    <span class="time">{{ calcularTiempoTranscurrido(item.createdAt) }}</span>
                </div>
            </div>
        </div>
        <div class="statistic">
            <div class="statistics-header">
                <h2>Tu resumen</h2>
                <p>Objetivos y actividades recientemente añadidas a tu página</p>
            </div>
            <div class="resume-cards">
                <div class="cards-objectives">
                    <div class="card-medium">
                        <h3>{{objectviesStarted}}</h3>
                        <p class="subtitle-medium">Objetivos empezados</p>
                        <p *ngIf="!isResponsive">Objetivos empezados</p>
                    </div>
                    <div class="card-medium">
                        <h3>{{objectivesPending}}</h3>
                        <p class="subtitle-medium">Objetivos pendientes</p>
                        <p *ngIf="!isResponsive">Objetivos que faltan resolver y no han sido empezados</p>
                    </div>
                </div>
                <div class="card-spinner">
                    <p>Objetivos en total ({{dataSource.length}})</p>
                    <div class="circle" [ngStyle]="getCircleStyle()">
                        <div class="circle-content">
                            <span class="percentage">{{percentagemFinished}}%</span>
                            <span class="text">Resumen</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</div>